import React from 'react'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import PolicyIcon from '@mui/icons-material/Policy'

import { PolicyListStyle } from '../styles'
import PolicyModal from '../modals/PolicyModal'
import ResourceDescription from '../shared/ResourceDescription'
import ResourceList from './ResourceList'
import { openExternal } from '../../utils/safeUrl'

const PolicyList = (props) => {
    const openResource = () => {
        openExternal(props.link)
        return false;
    }

    const secondary = (
        <>
            <ResourceDescription
                description={props.description}
                containerSx={PolicyListStyle.titleContainer}
                typographyProps={{ ...PolicyListStyle.description, gutterBottom: true }}
            />
            <Box sx={PolicyListStyle.secondary}>
                <Typography variant='p'>
                    <span style={{"fontWeight":"bold"}}>Country:</span> {props.country}
                </Typography>
            </Box>
            <Box sx={PolicyListStyle.secondary}>
                <Typography variant='p'>
                    <span style={{"fontWeight":"bold"}}>Date Enacted:</span> {props.enacted}
                </Typography>
            </Box>
            <Box sx={PolicyListStyle.secondary}>
                <Typography variant='p'>
                    <span style={{"fontWeight":"bold"}}>Date Last Updated:</span> {props.updated}
                </Typography>
            </Box>
        </>
    )

    return (
        <ResourceList
            Icon={PolicyIcon}
            listStyle={PolicyListStyle}
            modal={<PolicyModal {...props} />}
            title={props.title}
            date={props.pub_date}
            content_tags={props.content_tags}
            medical_specialty_tags={props.medical_specialty_tags}
            is_seminal_work={props.is_seminal_work || props.seminal_work}
            onOpen={openResource}
            secondaryContent={secondary}
        />
    )
}

export default PolicyList
